import React from 'react'
import { Skeleton } from '@chakra-ui/react'

export const ClassVideoLoader = () => {
  return (
    <Skeleton h={{ base: '300px', '2xl': '400px' }} w='full' borderRadius={5} />
  )
}
